import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    row-gap: ${({ theme }) => theme.spacing(1)};
`;

const ActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    column-gap: ${({ theme }) => theme.spacing(1)};
`;

const SearchContainer = styled.div`
    flex: 1 1 auto;
`;

export { Container, SearchContainer, ActionContainer };
